import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {
  AddBlockedByInput,
  CreateIssueAddBlockedByMutationMutation,
} from '@github-ui/server-persisted-queries/types/createIssueAddBlockedByMutation'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type CreateIssueAddBlockedByRequest = {
  input: AddBlockedByInput
}

export type CreateIssueAddBlockedByResponse = GraphQLResponse<CreateIssueAddBlockedByMutationMutation>

export async function apiCreateIssueAddBlockedBy(
  request: CreateIssueAddBlockedByRequest,
): Promise<CreateIssueAddBlockedByResponse> {
  const response = await reactFetchJSON('/_ghui/issues/blocked-by', {
    method: 'POST',
    body: request,
  })

  return response.json() as Promise<CreateIssueAddBlockedByResponse>
}
